import { NodeEnvironment } from "@/domains/common/types";

const EXTERNAL_LANDING_PAGE_REDIRECT_EXCLUDED_HOSTNAMES = new Set(["hack.mem.ai"]);

export const shouldRedirectToExternalLandingPage = ({
  hasPreviouslyVisitedLoginPage,
  hostname,
  isDesktop,
  isRootPage,
  nodeEnv,
}: {
  hasPreviouslyVisitedLoginPage: boolean;
  hostname: string | undefined;
  isDesktop: boolean;
  isRootPage: boolean;
  nodeEnv: NodeEnvironment;
}) => {
  if (isDesktop) return false;
  if (nodeEnv !== NodeEnvironment.Production) return false;
  if (hostname && EXTERNAL_LANDING_PAGE_REDIRECT_EXCLUDED_HOSTNAMES.has(hostname)) return false;
  if (!isRootPage) return false;
  if (hasPreviouslyVisitedLoginPage) return false;

  return true;
};
